import React from 'react';
import { Link } from "react-router-dom";
import { FaUsers, FaUserSlash, FaSignOutAlt, FaExclamationTriangle } from "react-icons/fa";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from 'react-bootstrap/Container';
import { getSecureItem, clearAllSecureData } from '../utils/encryption';
import env from "react-dotenv";

const URL = `${env.API_URL}/deleteProfile`;

class DeleteProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDeleting: false,
      error: null,
      showConfirmation: false,
      userId: null
    };
  }

  componentDidMount() {
    try {
      const appState = getSecureItem('p10-app-state');
      
      if (!appState || !appState.user?.id) {
        this.setState({ error: 'Session expired. Please log in again.' });
        return;
      }

      this.setState({ userId: appState.user.id });
    } catch (error) {
      console.error('Error loading user session:', error);
      this.setState({ error: 'Unable to verify your session. Please log in again.' });
    }
  }

  redirectToSignIn = () => {
    if (this.props.history) {
      this.props.history.push('/signin');
    } else {
      window.location.href = '/signin';
    }
  }

  redirectToProfile = () => {
    if (this.props.history) {
      this.props.history.push('/profile');
    } else {
      window.location.href = '/profile';
    }
  }

  handleDeleteClick = () => {
    this.setState({ showConfirmation: true, error: null });
  }

  handleCancelDelete = () => {
    this.setState({ showConfirmation: false, error: null });
  }

  onSubmitDelete = async () => {
    const { userId } = this.state;
    
    if (!userId) {
      this.setState({ error: 'Session expired. Please log in again.' });
      return;
    }

    this.setState({ isDeleting: true, error: null });

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000);
      
      const response = await fetch(URL, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': env.API_KEY
        },
        body: JSON.stringify({
        }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          throw new Error('Authentication failed. Please log in again.');
        } else if (response.status === 404) {
          throw new Error('Service not available. Please contact support.');
        } else if (response.status >= 500) {
          throw new Error('Server error. Please try again later.');
        }
        
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Unable to delete profile. Please try again.');
      }

      clearAllSecureData();
      
      alert('Your profile has been successfully deleted.');
      
      setTimeout(() => {
        this.redirectToSignIn();
      }, 500);

    } catch (error) {
      console.error('Delete profile error:', error);
      
      let errorMessage;
      
      if (error.name === 'AbortError') {
        errorMessage = 'Request timed out. Please check your connection and try again.';
      } else if (error.message.includes('Failed to fetch')) {
        errorMessage = 'Unable to connect to server. Please check your internet connection and try again.';
      } else {
        errorMessage = error.message || 'An unexpected error occurred. Please try again.';
      }
      
      this.setState({
        error: errorMessage,
        isDeleting: false
      });
    }
  }

  render() {
    const { isDeleting, error, showConfirmation } = this.state;

    if (typeof document !== 'undefined') {
      document.body.style.margin = '0';
      document.body.style.padding = '0';
    }

    return (
      <div style={{ minHeight: "100vh", backgroundColor: "#f8f9fa", margin: 0, padding: 0, position: 'absolute', top: 0, left: 0, right: 0 }}>
        {/* Navigation */}
        <Navbar expand="lg" bg="white" variant="light" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)', margin: 0, padding: '10px 0' }}>
          <Container fluid style={{ maxWidth: '1800px' }}>
            <Navbar.Brand href="/home" style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
              <img 
                src="/images/p10.jpg" 
                alt="P10" 
                style={{ 
                  height: '32px', 
                  width: '32px', 
                  marginRight: '8px',
                  borderRadius: '8px' 
                }}
              />
              <span style={{ fontWeight: '600', fontSize: '1.2rem', color: '#1f2937' }}>
                Delete Profile
              </span>
            </Navbar.Brand>
            
            <Navbar.Toggle aria-controls="main-navbar" />
            <Navbar.Collapse id="main-navbar">
              <Nav className="ms-auto">
                <Link to="/Main" className="nav-link" style={{ fontWeight: '600' }}>
                  <FaUsers style={{ marginRight: '6px' }}/> Profiles
                </Link>
                <Link to="/editProfile" className="nav-link" style={{ fontWeight: '600' }}>
                  <FaUserSlash style={{ marginRight: '6px' }}/> Edit Profile
                </Link>
                <Link to="/signin" className="nav-link" style={{ fontWeight: '600', color: '#e60023' }}>
                  <FaSignOutAlt style={{ marginRight: '6px' }}/> Log out
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Main Content */}
        <div style={{ maxWidth: 1200, margin: "20px auto 100px", padding: "0 20px" }}>
          <h1 style={{ 
            textAlign: "center", 
            fontSize: '2.5rem', 
            fontWeight: '700', 
            color: '#1f2937', 
            marginBottom: '10px' 
          }}>
            Delete Your Profile
          </h1>
          <h2 style={{ 
            textAlign: "center", 
            fontSize: '1.2rem', 
            color: '#6b7280', 
            marginBottom: '40px' 
          }}>
            This action cannot be undone
          </h2>

          <div style={{
            maxWidth: '700px',
            margin: '0 auto',
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 6px 18px rgba(0,0,0,0.06)',
            padding: '40px',
            textAlign: 'center'
          }}>
            <FaExclamationTriangle 
              size={60} 
              color="#ff6b6b" 
              style={{ marginBottom: '20px' }}
            />
            
            {!showConfirmation ? (
              <>
                <p style={{ 
                  fontSize: '16px', 
                  lineHeight: '1.6', 
                  marginBottom: '30px',
                  color: '#555'
                }}>
                  Are you sure you want to delete your profile? Once deleted, your profile will be permanently removed and this action cannot be undone.
                </p>
                
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  gap: '15px',
                  flexWrap: 'wrap'
                }}>
                  <button
                    onClick={this.redirectToProfile}
                    style={{
                      padding: '12px 30px',
                      backgroundColor: '#6b7280',
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px',
                      fontWeight: '700',
                      fontSize: '14px',
                      cursor: 'pointer',
                      minWidth: '120px',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={this.handleDeleteClick}
                    style={{
                      padding: '12px 30px',
                      backgroundColor: '#ff4444',
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px',
                      fontWeight: '700',
                      fontSize: '14px',
                      cursor: 'pointer',
                      minWidth: '180px',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#cc0000'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#ff4444'}
                  >
                    Continue to Delete
                  </button>
                </div>
              </>
            ) : (
              <>
                <div style={{
                  backgroundColor: '#ffe0e0',
                  border: '2px solid #ff0000',
                  borderRadius: '8px',
                  padding: '20px',
                  marginBottom: '20px'
                }}>
                  <p style={{ 
                    fontSize: '20px', 
                    fontWeight: 'bold', 
                    color: '#c00',
                    margin: 0
                  }}>
                    ⚠️ Final Confirmation
                  </p>
                </div>
                
                <p style={{ 
                  fontSize: '16px', 
                  lineHeight: '1.6', 
                  marginBottom: '30px',
                  color: '#555'
                }}>
                  This is your last chance to cancel. Click "Permanently Delete" to remove your account forever, or "Go Back" to keep your account.
                </p>

                {error && (
                  <div style={{
                    backgroundColor: '#ffe0e0',
                    border: '1px solid #ff0000',
                    borderRadius: '8px',
                    padding: '15px',
                    marginBottom: '20px',
                    color: '#c00',
                    fontSize: '14px'
                  }}>
                    <strong>Error:</strong> {error}
                  </div>
                )}

                {isDeleting && (
                  <div style={{ 
                    marginBottom: '20px',
                    padding: '15px',
                    backgroundColor: '#f0f9ff',
                    borderRadius: '8px'
                  }}>
                    <p style={{ color: '#0369a1', fontWeight: 'bold', margin: 0 }}>
                      ⏳ Deleting your profile...
                    </p>
                  </div>
                )}

                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  gap: '15px',
                  flexWrap: 'wrap'
                }}>
                  <button
                    onClick={this.handleCancelDelete}
                    disabled={isDeleting}
                    style={{
                      padding: '12px 30px',
                      backgroundColor: '#6b7280',
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px',
                      fontWeight: '700',
                      fontSize: '14px',
                      cursor: isDeleting ? 'not-allowed' : 'pointer',
                      opacity: isDeleting ? 0.5 : 1,
                      minWidth: '120px',
                      transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => !isDeleting && (e.target.style.backgroundColor = '#4b5563')}
                    onMouseLeave={(e) => !isDeleting && (e.target.style.backgroundColor = '#6b7280')}
                  >
                    Go Back
                  </button>
                  <button
                    onClick={this.onSubmitDelete}
                    disabled={isDeleting}
                    style={{
                      padding: '12px 30px',
                      backgroundColor: '#8b0000',
                      color: 'white',
                      border: 'none',
                      borderRadius: '10px',
                      fontWeight: '700',
                      fontSize: '14px',
                      cursor: isDeleting ? 'not-allowed' : 'pointer',
                      opacity: isDeleting ? 0.6 : 1,
                      minWidth: '180px',
                      transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => !isDeleting && (e.target.style.backgroundColor = '#660000')}
                    onMouseLeave={(e) => !isDeleting && (e.target.style.backgroundColor = '#8b0000')}
                  >
                    {isDeleting ? 'Deleting...' : '🗑️ Permanently Delete'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{ 
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb',
          padding: '20px 0',
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
        }}>
          <Container>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '20px',
              fontSize: '0.9rem'
            }}>
              <span style={{ color: '#6b7280' }}>© 2025 p10rating</span>
              <Link to="/privacypolicy" style={{ color: '#3b82f6', textDecoration: 'none' }}>
                Privacy
              </Link>
              <Link to="/disclaimer" style={{ color: '#3b82f6', textDecoration: 'none' }}>
                Disclaimer
              </Link>
              <Link to="/terms" style={{ color: '#3b82f6', textDecoration: 'none' }}>
                Terms
              </Link>
              <Link to="/about" style={{ color: '#3b82f6', textDecoration: 'none' }}>
                About
              </Link>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}

export default DeleteProfile;